<template>
  <button
    type="button"
    class="button-unstyled pin-button"
    :class="{ '-pinned': pinned }"
    :title="$t(pinned ? 'nav.unpin_feed' : 'nav.pin_feed')"
    :aria-label="$t('nav.pin_feed_named', { name: label })"
    :aria-pressed="pinned ? 'true' : 'false'"
    @click.stop.prevent="togglePin(name)"
  >
    <FAIcon
      fixed-width
      icon="thumbtack"
      :transform="pinned ? '' : 'rotate-45'"
    />
  </button>
</template>

<script>
import { pinnedNames, togglePin } from 'src/components/navigation/feed_store.js'

// Pins a feed to the timeline header (its icon next to the title)
export default {
  props: {
    // the feed's name among the pins: 'home', 'list-<id>', 'tag-<name>'…
    name: { type: String, required: true },
    // the feed's name as people read it, for screen readers
    label: { type: String, required: true },
  },
  computed: {
    pinned() {
      return pinnedNames().includes(this.name)
    },
  },
  methods: { togglePin },
}
</script>
